var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9818",
    "data-name": "Trac\\xE9 9818",
    d: "M12,25.333h5.139a1.528,1.528,0,0,0,1.528-1.528V19.292a.625.625,0,0,1,.625-.625h8.75a.625.625,0,0,1,.625.625V45.333h-5A1.667,1.667,0,0,0,22,47v5H42V47a1.667,1.667,0,0,0-1.667-1.667h-5V19.315a.648.648,0,0,1,.648-.648h8.727a.625.625,0,0,1,.625.625v4.514a1.528,1.528,0,0,0,1.528,1.528H52V13.25A1.25,1.25,0,0,0,50.75,12H13.25A1.25,1.25,0,0,0,12,13.25Z",
    transform: "translate(-12 -12)",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.f9df806973d9901e4d5d73038b9e7c25.svg";
export { ForwardRef as ReactComponent };